import React from 'react';

import Button from '../../components/Button';
import Footer from '../../components/Footer';

import './Mobile.css';


const CONTRIBUTE_LINK = "https://www.patreon.com/bePatron?u=22305545";


const Component = () => (
  <div className="support_main_m">
    <div className="support_sec1_m">
      <div className="support_sec1Overlay_m">
        <div className="support_sec1_textContainer_m">
          <div className="support_header_white_m" >
            Culture and Sustainability
          </div>
          <div className="support_body_white_m">
            Through the pursuit of vibrant local culture we believe communities will find
            new and unique solutions to sustainability issues. Baloo provides you with
            the tools and knowledge to invigorate your community’s culture.
          </div>
        </div>
        <Button link={CONTRIBUTE_LINK}>
          Contribute
        </Button>
      </div>
    </div>

    <div className="support_nonprofitSec_m">
      <div className="support_header_m">
        A nonprofit<br />technology company
      </div>
      <div className="support_body_m">
        As a nonprofit, Baloo aims to prove innovation can be achieved without
        multi-million dollar paychecks. With support from our members and motivation
        from making a positive impact, we’re able to create impactful technology
        without selling your data and inundating you with ads.
      </div>

      <div className="support_islandCircle_m" />
    </div>


    <div className="support_supportSec_m">
      <div className="support_supportSec_textSpacer_m">
        <div className="support_header_left_m">
          Support Us
        </div>
        <div className="support_body_left_m">
          You can support the development of Baloo through our Patreon. As a contributor,
          you’ll receive updates about the progress of Baloo development and expense
          updates so you know how your funds are being spent.
        </div>
      </div>
      <Button link={CONTRIBUTE_LINK}>
        Contribute
      </Button>
    </div>


    <Footer />
  </div>
);

Component.displayName = 'Mobile';

export default Component;



// WEBPACK FOOTER //
// ./src/views/Support/Mobile.js